import React from "react";
import LiteYouTubeEmbed from "react-lite-youtube-embed";
import "react-lite-youtube-embed/dist/LiteYouTubeEmbed.css";

import { EuiCard, EuiFlexGroup, EuiFlexItem, EuiText } from "@elastic/eui";

export default function softwareVideos() {
  return (
    <React.Fragment>
      <EuiFlexGroup gutterSize="l" direction="row" style={{ margin: "0 7px" }}>
        <EuiFlexItem>
          <EuiCard
            textAlign="left"
            image={
              <LiteYouTubeEmbed
                id="C-Rn9jdi_4o"
                title="INSTAR Ultra-HD Serien: RTSP Videostream abgreifen sowie Fragmented MP4 und MJPEG Stream und JPEG Snapshot"
                adNetwork={true}
                poster="maxresdefault" //hqdefault
                noCookie={true}
              />
            }
            title="INSTAR Ultra-HD Serien Videostream"
            footer={
              <EuiText>
                <p>
                  INSTAR Ultra-HD Serien: RTSP Videostream abgreifen sowie
                  Fragmented MP4 und MJPEG Stream und JPEG Snapshot
                </p>
              </EuiText>
            }
          />
        </EuiFlexItem>
      </EuiFlexGroup>
    </React.Fragment>
  );
}
